import { useState } from 'react';
import { Form } from 'antd';
import { useCreateEmployer, useGetListEmployer } from '@/hooks/v2/employer';

const { useWatch } = Form;

interface UseEmployerProps {
	fieldName?: string | string[];
}

export function useEmployer({ fieldName }: UseEmployerProps) {
	const field = Array.isArray(fieldName) ? fieldName[0] : null;

	const organizationId = useWatch(field ? [field, 'organization_id'] : 'organization_id');
	const companyId = useWatch(field ? [field, 'company_id'] : 'company_id');
	const [name, setName] = useState<string>('');

	const { mutate: createEmployer } = useCreateEmployer();

	const { isLoading, data: employers } = useGetListEmployer({
		organization_id: organizationId,
		company_id: companyId
	});

	function handleInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
		setName(event.target.value);
	}

	function addItem(e: React.MouseEvent<HTMLAnchorElement>): void {
		e.preventDefault();

		if (!name.trim()) {
			return;
		}

		createEmployer({
			name: name.trim(),
			company_id: companyId,
			organization_id: organizationId
		});

		setName('');
	}

	function handleSearch(value: string): void {
		if (value.length > 2) {
		}
	}

	const data =
		employers && employers.rows
			? employers.rows.map((item) => ({
					label: item.name,
					value: item.id
				}))
			: [];

	return { isLoading, data, addItem, handleSearch, handleInputChange };
}
